import _ from "lodash";

const AUTOMATION_BLOCK_TYPES = {
    START_POINT: "START_POINT",
    DEFAULT_FALLBACK: "DEFAULT_FALLBACK",
    DEFAULT_TIMEOUT: "DEFAULT_TIMEOUT",
    FALLBACK: "FALLBACK",
    TIMEOUT: "TIMEOUT",
    FILTER: "FILTER",
    SLEEP: "SLEEP",
    NOOP: "NOOP",
    FLOW: "FLOW",
    GO_TO_STEP: "GO_TO_STEP",
    ADD_TO_SEGMENT: "ADD_TO_SEGMENT",
    REMOVE_FROM_SEGMENT: "REMOVE_FROM_SEGMENT",
    WEBHOOK: "WEBHOOK",
    CATCH_WEBHOOK: "CATCH_WEBHOOK",
    SET_ATTRIBUTE: "SET_ATTRIBUTE",
    TERMINATE_AUTOMATION: "TERMINATE_AUTOMATION",
    CREATE_TICKET: "CREATE_TICKET",
    //TRANSFER_CHAT: "TRANSFER_CHAT",
    //TRANSFER_TO_CHATBOT: "TRANSFER_TO_CHATBOT",
    //SET_DEPARTMENT: "SET_DEPARTMENT",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    CREATE_RESERVATION: "CREATE_RESERVATION",
    SEND_SMS: "SEND_SMS",
    SEND_MAIL: "SEND_MAIL",
    CREATE_EVENT: "CREATE_EVENT",
    CREATE_TASK: "CREATE_TASK",
    //SUPPRESSION_ADD: "SUPPRESSION_ADD",
    //SUPPRESSION_REMOVE: "SUPPRESSION_REMOVE",
    SEND_WP_BUSINESS_MESSAGE: "SEND_WP_BUSINESS_MESSAGE",
    WAIT_FOR: "WAIT_FOR",
    MESSAGE_RECEIVED: "MESSAGE_RECEIVED",
    ASK_AI: "ASK_AI",
    CREATE_CONTACT: "CREATE_CONTACT",
    UPDATE_CONTACT: "UPDATE_CONTACT",
    //FIND_CONTACT_BY_EMAIL: "FIND_CONTACT_BY_EMAIL",
    //FIND_CONTACT_BY_NUMBER: "FIND_CONTACT_BY_NUMBER",
    FIND_CONTACTS: "FIND_CONTACTS",
    FIND_CONTACT: "FIND_CONTACT",
    //FIND_CHATS: "FIND_CHATS",
    //FIND_CHAT: "FIND_CHAT",
    LOOP: "LOOP",
    LOOP_NEXT: "LOOP_NEXT",
    LOOP_FINISH: "LOOP_FINISH",
    LOOP_BREAK: "LOOP_BREAK",
    LOOP_CONTINUE: "LOOP_CONTINUE",

    UPDATE_PROFILE: "UPDATE_PROFILE",
    STRING_FORMAT: "STRING_FORMAT",
    NUMBER_FORMAT: "NUMBER_FORMAT",
    DATE_FORMAT: "DATE_FORMAT",
    RECORDS_FROM_CSV: "RECORDS_FROM_CSV",

    TABLE_CREATE_RECORD: "TABLE_CREATE_RECORD",
    TABLE_DELETE_RECORD: "TABLE_DELETE_RECORD",
    TABLE_UPDATE_RECORD: "TABLE_UPDATE_RECORD",
    TABLE_FIND_RECORD: "TABLE_FIND_RECORD",
    TABLE_FIND_RECORDS: "TABLE_FIND_RECORDS",

    ZOHO_FIND_RECORDS_BY_PHONE: "ZOHO_FIND_RECORDS_BY_PHONE",
    ZOHO_ADD_ATTACHMENT_TO_RECORD: "ZOHO_ADD_ATTACHMENT_TO_RECORD",
    ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD",
    ZOHO_CREATE_RECORD: "ZOHO_CREATE_RECORD",

    GET_SUPSIS_RECORD_BY_ID: "GET_SUPSIS_RECORD_BY_ID",

    TICKET_UPDATE: "TICKET_UPDATE",

    UPDATE_TASK: "UPDATE_TASK",
    ASSIGN_OWNER: "ASSIGN_OWNER",

    REPLY_TRENDYOL_QUESTION: "REPLY_TRENDYOL_QUESTION",
    SHOW_WIDGET: "SHOW_WIDGET",
    
    AI_CALL: "AI_CALL",

    // OpenRouter LLM Response Blocks
    OPENROUTER_RESPONSE: "OPENROUTER_RESPONSE",
    OPENAI_RESPONSE: "OPENAI_RESPONSE",
    GOOGLE_AI_RESPONSE: "GOOGLE_AI_RESPONSE",
    ANTHROPIC_RESPONSE: "ANTHROPIC_RESPONSE",
    MISTRAL_RESPONSE: "MISTRAL_RESPONSE",
    AZURE_RESPONSE: "AZURE_RESPONSE",
    BEDROCK_RESPONSE: "BEDROCK_RESPONSE",
    COHERE_RESPONSE: "COHERE_RESPONSE",
    XAI_RESPONSE: "XAI_RESPONSE",
    DEEPINFRA_RESPONSE: "DEEPINFRA_RESPONSE",
    TOGETHER_RESPONSE: "TOGETHER_RESPONSE",
    FIREWORKS_RESPONSE: "FIREWORKS_RESPONSE",
    SILICONFLOW_RESPONSE: "SILICONFLOW_RESPONSE",
    PARASAIL_RESPONSE: "PARASAIL_RESPONSE",
    NEBIUS_RESPONSE: "NEBIUS_RESPONSE",
    ALIBABA_RESPONSE: "ALIBABA_RESPONSE",
    XIAOMI_RESPONSE: "XIAOMI_RESPONSE",
    SAMBANOVA_RESPONSE: "SAMBANOVA_RESPONSE",
    MOONSHOT_RESPONSE: "MOONSHOT_RESPONSE",
    MINIMAX_RESPONSE: "MINIMAX_RESPONSE",
    NVIDIA_RESPONSE: "NVIDIA_RESPONSE",
    
    SEND_JSON_RESPONSE: "SEND_JSON_RESPONSE",

    RUN_JAVASCRIPT: "RUN_JAVASCRIPT",

    META_SEND_CAPI_EVENT: "META_SEND_CAPI_EVENT",

    CACHE_WRITE: "CACHE_WRITE",
    CACHE_READ: "CACHE_READ",
    CACHE_EXTEND: "CACHE_EXTEND",
    CACHE_DELETE: "CACHE_DELETE",

    YOUTUBE_REPLY_COMMENT: "YOUTUBE_REPLY_COMMENT",
    YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE_UPDATE_COMMENT_STATUS",
    YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE_SET_MODERATION_STATUS",

    GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE_BUSINESS_REPLY_REVIEW",
    GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS",

    GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE_PLAY_REPLY_REVIEW",
    GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE_PLAY_UPDATE_REVIEW_STATUS",

    APP_STORE_REPLY_REVIEW: "APP_STORE_REPLY_REVIEW",
    APP_STORE_UPDATE_REVIEW_STATUS: "APP_STORE_UPDATE_REVIEW_STATUS",
    APP_STORE_DELETE_REVIEW_RESPONSE: "APP_STORE_DELETE_REVIEW_RESPONSE",

    GOOGLE_DRIVE_UPLOAD_FILE: "GOOGLE_DRIVE_UPLOAD_FILE",
    GOOGLE_DRIVE_DOWNLOAD_FILE: "GOOGLE_DRIVE_DOWNLOAD_FILE",
    GOOGLE_DRIVE_GET_FILE_INFO: "GOOGLE_DRIVE_GET_FILE_INFO",
    GOOGLE_DRIVE_DELETE_FILE: "GOOGLE_DRIVE_DELETE_FILE",
};

AUTOMATION_BLOCK_TYPES.ALL_BLOCKS = Object.keys(AUTOMATION_BLOCK_TYPES).map((key) => AUTOMATION_BLOCK_TYPES[key]);

AUTOMATION_BLOCK_TYPES.TERMINATION_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION,
    AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
    AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
    AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
];
AUTOMATION_BLOCK_TYPES.MULTI_CHILD_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.WEBHOOK,
    AUTOMATION_BLOCK_TYPES.CREATE_EVENT,
    AUTOMATION_BLOCK_TYPES.CREATE_RESERVATION,
    AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
    AUTOMATION_BLOCK_TYPES.WAIT_FOR,
    AUTOMATION_BLOCK_TYPES.ZOHO_FIND_RECORDS_BY_PHONE,
    AUTOMATION_BLOCK_TYPES.ZOHO_ADD_ATTACHMENT_TO_RECORD,
    AUTOMATION_BLOCK_TYPES.ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD,
    AUTOMATION_BLOCK_TYPES.ZOHO_CREATE_RECORD,
    AUTOMATION_BLOCK_TYPES.AI_CALL,
    AUTOMATION_BLOCK_TYPES.META_SEND_CAPI_EVENT,
];
AUTOMATION_BLOCK_TYPES.INPUT_BLOCKS = [];
AUTOMATION_BLOCK_TYPES.MAIN_RESTRICT_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
    AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION,
    AUTOMATION_BLOCK_TYPES.WEBHOOK,
];
AUTOMATION_BLOCK_TYPES.SPECIAL_BLOCKS = [];

AUTOMATION_BLOCK_TYPES.TAILED_FLOW_BLOCKS = [];

const isElseIfBlockPattern = (block, sourceType) => {
    block = _.cloneDeep(block);
    const validPatterns = [
        [AUTOMATION_BLOCK_TYPES.FALLBACK],
        [AUTOMATION_BLOCK_TYPES.FILTER],
        [AUTOMATION_BLOCK_TYPES.FILTER, AUTOMATION_BLOCK_TYPES.FALLBACK],
        [AUTOMATION_BLOCK_TYPES.ADD_TO_SEGMENT],
        [AUTOMATION_BLOCK_TYPES.REMOVE_FROM_SEGMENT],
        [AUTOMATION_BLOCK_TYPES.TIMEOUT],
        [AUTOMATION_BLOCK_TYPES.FALLBACK, AUTOMATION_BLOCK_TYPES.TIMEOUT],
    ].map((arr) => _.orderBy(arr, (q) => q, ["asc"]));
    const currentPattern = _.chain(
        _.concat(
            block.children.map((child) => child.type),
            [sourceType]
        )
    )
        .uniq()
        .orderBy((q) => q, ["asc"])
        .value();
    const isValid = _.some(validPatterns, (pattern) => _.isEqual(pattern, currentPattern));
    console.log("isElseIfBlockPattern 2", {
        block,
        sourceType,
        validPatterns,
        currentPattern,
        isValid,
    });
    return isValid;
};
AUTOMATION_BLOCK_TYPES.isElseIfBlockPattern = isElseIfBlockPattern;
export default AUTOMATION_BLOCK_TYPES;
